import { actionTypes } from "../constant/action-types";

export function SaveGroupsList(data) {
  return {
    type: actionTypes.SAVE_GROUPS,
    payload: data,
  };
}

export function SaveContactList(data) {
  return {
    type: actionTypes.SAVE_CONTACT_LIST,
    payload: data,
  };
}

export function SaveMessages(data) {
  return {
    type: actionTypes.SAVE_MESSAGES,
    payload: data,
  };
}

// Prepends an older page of messages onto the front of the currently loaded
// list, instead of replacing it — used when the user scrolls up to load
// history rather than opening a conversation for the first time.
export function PrependMessages(data) {
  return {
    type: actionTypes.PREPEND_MESSAGES,
    payload: data,
  };
}

// Merges a freshly fetched newest page into the loaded messages, keeping any
// older pages the user has scrolled up to.
export function MergeLatestMessages(data) {
  return {
    type: actionTypes.MERGE_LATEST_MESSAGES,
    payload: data,
  };
}

// Applies a change (edit / delete) to one loaded message in place.
export function PatchMessage(conversationId, messageId, patch) {
  return {
    type: actionTypes.PATCH_MESSAGE,
    payload: { conversation_id: conversationId, message_id: messageId, patch },
  };
}

export function saveChatReceivedMessage(data) {
  console.log("saveChatReceivedMessage", data);
  return {
    type: actionTypes.SAVE_RECEIVED_MESSAGES,
    payload: data,
  };
}

export function saveLastMessageList(data) {
  return {
    type: actionTypes.SAVE_LAST_MESSAGE_IDS,
    payload: data,
  };
}

export function selectedChatMember(data) {
  return {
    type: actionTypes.SELECTED_CHAT_MEMBER,
    payload: data,
  };
}
